import React from 'react';
import { useTheme } from '@chakra-ui/react';
import { Toaster } from 'react-hot-toast';

/**
 * Toaster component with theme-aware configuration
 * Uses Chakra UI theme colors instead of hardcoded hex values
 */
export const ToasterConfig: React.FC = () => {
  const theme = useTheme();

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        // Default options for all toasts
        duration: 4000,
        style: {
          background: theme.colors.gray[700],
          color: '#fff',
          fontSize: '0.875rem',
          fontWeight: '500',
          borderRadius: '0.375rem',
          padding: '0.75rem 1rem',
          boxShadow:
            '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
        // Success toast
        success: {
          duration: 3000,
          iconTheme: {
            primary: theme.colors.green[400],
            secondary: '#fff',
          },
        },
        // Error toast
        error: {
          duration: 5000,
          iconTheme: {
            primary: theme.colors.red[400],
            secondary: '#fff',
          },
        },
        // Loading toast
        loading: {
          iconTheme: {
            primary: theme.colors.blue[400],
            secondary: '#fff',
          },
        },
      }}
    />
  );
};
